import {NgModule} from '@angular/core';
import {BreadcrumbsComponent} from '../components/breadcrumbs.component';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import { FuiTooltipDirective } from '@fui/fui-components';

@NgModule({
    declarations: [BreadcrumbsComponent],
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        FuiTooltipDirective,
    ],
    exports: [BreadcrumbsComponent]
})
export class BreadcrumbsModule {
}
